import {
    addSetting,
    deleteSetting,
    getSetting,
    getSettings,
    setSetting,
    updateSetting,
} from "../../api/globalSettings";
import { sendSocketMessage } from "../../utils/socketStream";

const globalSettings = {
    namespace: true,
    state: {
        globalSettings: {
            settings: [],
        },
    },
    getters: {
        getSettingByKey: (state) => (key) => {
            const setting = state.globalSettings.settings.find((s) => s.key === key);
            if (!setting) return null;
            if (setting.type === "number") {
                return parseFloat(setting.value);
            }
            if (setting.type === "boolean") {
                return setting.value === "true";
            }
            return setting.value;
        },
        baseTaxRate: (state, getters) => {
            return getters.getSettingByKey("config.tablet.payment.config.taxRate") || 0.2;
        },
    },
    mutations: {
        FETCH_SETTINGS: (state, payload) => {
            state.globalSettings.settings = payload;
        },
        NEW_SETTING: (state, payload) => {
            state.globalSettings.settings.push(payload);
        },
        DELETE_SETTING: (state, payload) => {
            state.globalSettings.settings = state.globalSettings.settings.filter((setting) => setting._id !== payload);
        },
        UPDATE_SETTING: (state, payload) => {
            state.globalSettings.settings = state.globalSettings.settings.map((setting) => {
                if (setting._id === payload.id) {
                    return {
                        ...setting,
                        value: payload.value,
                    };
                }
                return setting;
            });
        },
        FETCH_SETTING: (state, payload) => {
            let maybeSetting = state.globalSettings.settings.findIndex((setting) => setting._id === payload._id);
            if (maybeSetting > -1) {
                state.globalSettings.settings[maybeSetting] = payload;
            } else {
                state.globalSettings.settings.push(payload);
            }
        },
        UPDATE_SETTING_FIELD: (state, payload) => {
            state.globalSettings.settings = state.globalSettings.settings.map((setting) => {
                if (setting._id === payload.id) {
                    return {
                        ...setting,
                        ...payload.params,
                    };
                }
                return setting;
            });
        },
    },
    actions: {
        fetchSettings: async ({ commit }) => {
            let response = await getSettings();
            commit("FETCH_SETTINGS", response.data);
            return response;
        },
        getSetting: async ({ commit }, data) => {
            if (data.isDelete) {
                commit("DELETE_SETTING");
            } else {
                let response = await getSetting(data.id);
                if (response.status === 200) {
                    commit("FETCH_SETTING", response.data);
                }
            }
        },
        newSetting: async ({ commit, rootState }, payload) => {
            let response = await addSetting(payload);
            if (response.status === 201) {
                commit("NEW_SETTING", response.data);
                sendSocketMessage("global-settings", {
                    siteId: rootState.site.site._id,
                    id: response.data._id,
                    isDelete: false,
                });
            }
            return response;
        },
        deleteSetting: async ({ commit, rootState }, payload) => {
            let response = await deleteSetting(payload);
            if (response.status === 200) {
                commit("DELETE_SETTING", payload);
                sendSocketMessage("global-settings", {
                    siteId: rootState.site.site._id,
                    id: response.data._id,
                    isDelete: true,
                });
            }
        },
        setSetting: async ({ commit, rootState }, payload) => {
            let response = await setSetting(payload);
            if (response.status === 200) {
                commit("UPDATE_SETTING", payload);
                sendSocketMessage("global-settings", {
                    siteId: rootState.site.site._id,
                    id: response.data._id,
                    isDelete: false,
                });
            }
        },
        updateSetting: async ({ commit, rootState }, payload) => {
            let response = await updateSetting(payload);
            if (response.status === 200) {
                commit("UPDATE_SETTING_FIELD", payload);
                sendSocketMessage("global-settings", {
                    siteId: rootState.site.site._id,
                    id: response.data._id,
                    isDelete: false,
                });
            }
            return response;
        },
    },
};

export default globalSettings;
